<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="text-body-1 text-sm-h6">
					<span class="black--text text-uppercase font-weight-bold">Filter</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row align="center" justify="center">
						<v-col cols="12" class="pt-0 pb-1" v-if="false">
							<div class="text-body-2 font-weight-bold pb-1">Urutkan</div>
							<div class="d-flex flex-wrap">
								<v-btn v-for="(data, index) in listSort" :key="index" @click="selectedSort = data" :outlined="selectedSort != data" color="black" class="mr-2 mb-2 rounded-lg text-capitalize text-body-2">{{data.sortLabel}}</v-btn>
							</div>
						</v-col>
						<v-col cols="12" class="pt-0 pb-1" v-if="$route.query.type == 'product'">
							<div class="pb-1 d-flex justify-space-between">
								<div class="text-body-2 font-weight-bold">Kategori</div>
								<div class="text-body-2 font-weight-bold black--text" @click="showMorecategory = !showMorecategory">{{showMorecategory ? "Sembunyikan" : "Lihat Semua"}}</div>
							</div>
							<div class="d-flex flex-wrap mt-1">
								<v-btn v-for="(data, index) in categoryList" :key="index" :outlined="selectedCategory != data.product_category_slug" color="black" class="mr-2 mb-2 rounded-lg text-capitalize text-body-2" @click="selectCategory(data)">{{data.product_category_name}}</v-btn>
							</div>
						</v-col>
						<v-col cols="12" class="pt-0 pb-1">
							<div class="text-body-2 font-weight-bold pb-1">Tipe Toko</div>
							<v-row>
								<v-col cols="12" class="mt-n5 pb-2 pr-1">
								<v-checkbox color="orange darken-1" v-model="official_store" hide-details dense>
									<template v-slot:label>
										<strong class="orange--text text--darken-1">Store Partner</strong>
									</template>
								</v-checkbox>
							</v-col>
							</v-row>
							<!-- <div class="pb-1 d-flex justify-space-between">
								<div class="text-body-2 font-weight-bold">Tipe Toko</div>
							</div>
							<div>
								<v-checkbox color="orange darken-1" hide-details>
									<template v-slot:label>
										<strong class="orange--text text--darken-1">Store Partner</strong>
									</template>
								</v-checkbox>
							</div> -->
						</v-col>
						<v-col cols="12" class="pt-0 pb-1" v-if="$route.query.type == 'product'">
							<div class="text-body-2 font-weight-bold pb-1">Harga</div>
							<v-row>
								<v-col cols="6" class="pt-0 pb-2 pr-1">
									<v-text-field v-model="priceMinFilter.value" outlined dense placeholder="Minimal" class="rounded-lg text-body-2" hide-details></v-text-field>
								</v-col>
								<v-col cols="6" class="pt-0 pb-2 pl-1">
									<v-text-field outlined dense placeholder="Maximal" class="rounded-lg text-body-2" hide-details></v-text-field>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" class="pt-0 pb-1" v-if="false">
							<div class="pb-1 d-flex justify-space-between">
								<div class="text-body-2 font-weight-bold">Lokasi</div>
								<div class="text-body-2 font-weight-bold primary--text">Sembunyikan</div>
							</div>
							<div class="d-flex flex-wrap">
								<v-btn outlined color="primary" class="mr-2 mb-2 rounded-lg text-capitalize text-body-2">Jakarta</v-btn>
								<v-btn outlined color="grey darken-1" class="mr-2 mb-2 rounded-lg text-capitalize text-body-2">Yogyakarta</v-btn>
							</div>
						</v-col>
						<v-col cols="12" class="pt-0 pb-1" v-if="false">
							<div class="pb-1 d-flex justify-space-between">
								<div class="text-body-2 font-weight-bold">Pengiriman</div>
								<div class="text-body-2 font-weight-bold primary--text">Lihat Semua</div>
							</div>
							<div class="d-flex flex-wrap">
								<v-btn outlined color="primary" class="mr-2 mb-2 rounded-lg text-capitalize text-body-2">JNE</v-btn>
								<v-btn outlined color="grey darken-1" class="mr-2 mb-2 rounded-lg text-capitalize text-body-2">J&T</v-btn>
							</div>
						</v-col>
						<v-col cols="12" class="pt-0 pb-1" v-if="false">
							<div class="text-body-2 font-weight-bold pb-1">Rating</div>
							<div class="d-flex flex-wrap">
								<v-btn outlined color="primary" class="mr-2 mb-2 rounded-lg text-capitalize text-body-2">
									<v-icon color="yellow darken-1">mdi-star</v-icon>
									<span class="pl-1">4 Keatas</span>
								</v-btn>
								<v-btn outlined color="grey darken-1" class="mr-2 mb-2 rounded-lg text-capitalize text-body-2">
									<v-icon color="yellow darken-1">mdi-star</v-icon>
									<span class="pl-1">3 Keatas</span>
								</v-btn>
							</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-col cols="12" class="py-2 text-center">
						<v-btn @click="doFilter" depressed color="black" large class="text-capitalize font-weight-bold text-body-2 rounded-lg white--text">Filter</v-btn>
					</v-col>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	data () {
		return {
			dialog: false,
			showMorecategory: false,
			selectedCategory: '',
			selectedSort: {},
			official_store: false,
		}
	},
	props: {
		category: {
			type: Array
		},
		priceMinFilter: {
			type: Object
		},
		priceMaxFilter: {
			type: Object
		},
		listSort: {
			typë: Array
		},
		categorySelected: {
			type: String
		},
		storePartner: {
			type: Boolean
		},
	},
	computed: {
		categoryList() {
			let category = []
			if (this.category.length > 0) {
				if (this.showMorecategory) {
					category = this.category
				} else {
					category = this.category.slice(0, 3)
				}
			}
			return category
		},
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		modalShow() {
			this.selectedCategory = this.categorySelected
			this.official_store = this.storePartner
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		selectCategory(data) {
			if (this.selectedCategory == data.product_category_slug) {
				this.selectedCategory = ""
			} else {
				this.selectedCategory = data.product_category_slug
			}
		},
		doFilter() {
			let params = {
				category: this.selectedCategory,
				// sort: this.selectedSort,
				priceMax: this.priceMaxFilter,
				priceMin: this.priceMinFilter,
				storePartner: this.official_store,
			}
			this.$emit('action', params)
			this.modalHide()
		}
	},
};
</script>